export default "__VITE_ASSET__0ba179f6__"